var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScholarship(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 291.96 302.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#e6e5e5;}.cls-2{stroke:#e6e5e5;stroke-width:0.65px;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-3{font-size:95.55px;stroke:#b4b4b4;stroke-width:1.03px;font-family:MyriadPro-Regular, Myriad Pro;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.39,292.72c-3.2-3-34-31.45-55.12-40.58-20.82-9-49.65-12-53.41-12.35a193.06,193.06,0,0,1,19.63-56.25c9-16.42,19.93-29.5,32.54-38.88,15.75-11.71,34.15-17.65,54.7-17.65s39,5.94,54.7,17.65C210,154,221,167.12,230,183.55a193,193,0,0,1,19.63,56.26c-3.74.49-33.31,4.52-53.29,13.11C176.08,261.6,147.43,289.7,144.39,292.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.72,127.39c20.46,0,38.78,5.91,54.46,17.57,12.56,9.34,23.47,22.38,32.43,38.75a193.07,193.07,0,0,1,19.54,55.77c-5.08.67-33.56,4.72-53,13.08-19.8,8.51-47.62,35.54-51.77,39.63-4.37-4.06-34.27-31.46-55-40.4C69.18,243,41.4,240,36.3,239.45a193.1,193.1,0,0,1,19.53-55.74c9-16.37,19.87-29.41,32.43-38.75,15.68-11.66,34-17.57,54.46-17.57m0-.76c-90.47,0-107.3,113.5-107.3,113.5s31.3,2.68,53.7,12.36,55.28,40.76,55.28,40.76,30.61-30.77,52.05-40S250,240.13,250,240.13s-16.83-113.5-107.3-113.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.17,302.29,24.4,191c3.1-2.68,5.35-10.47,5.35-19.68,0-8.34-1.85-15.51-4.5-18.78V97.43H18.83v55.08c-2.65,3.27-4.5,10.44-4.5,18.78,0,10,2.64,18.32,6.15,20.26L11.76,302.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.65 98.07 144.49 0.46 291.3 97.06 144.71 210.03 0.65 98.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.49.92,290.65,97.09,144.71,209.55,1.29,98.09,144.49.92m0-.92L0,98,144.71,210.51,292,97,144.48,0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(116.18 177.19) scale(0.99 1)"
  }, "$")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarship);
export default __webpack_public_path__ + "static/media/scholarship.5595685f30019074d652fe51829eed3a.svg";
export { ForwardRef as ReactComponent };